import React from 'react';
import { Box } from '@mui/material';
import AssetronFooter from '../components/common/AssetronFooter';
import AssetronHeader from '../components/common/AssetronHeader';

function HeaderFooterLayout({ children }: { children: React.ReactNode }) {
  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <AssetronHeader />
      {children}
      <AssetronFooter />
    </Box>
  );
}

export default HeaderFooterLayout;
